module.exports = "/_next/static/images/068c60ec1fb83d4047108a5564b217b0-man-with-cellphone-lg@2x.jpg.webp";